import storage from "../../../../../utils/storage";
import {io} from "socket.io-client";
import {SOCKET_PATH, SOCKET_URL} from "../../../../../constants";

let socket;

const initializeSocket = (props) => {
  const { setSocketConnected, logOutUser } = props;

  const accessToken = storage.retrieveAccessToken();

  socket = io(SOCKET_URL, {
    path: SOCKET_PATH,
    auth: {
      token: accessToken.substring(7)
    },
  });

  socket.on("connect", () => {
    setSocketConnected(true)
  });

  socket.on("connect_error", (err) => {
    if (err.message === "invalid credentials") {
      storage.refreshAccessToken().then(() => {
        const accessToken = storage.retrieveAccessToken();
        if(accessToken) {
          socket.auth.token = accessToken.substring(7);
          socket.connect();
        }
      })
    }
  });

  socket.on("server-error", (err) => {
    console.log(err.msg)
    if (err.msg === "invalid credentials") {
      logOutUser()
    }
  });

  // Destroys the socket reference
  // when the connection is closed
  return () => {
    socket.disconnect();
  };
}

const changeCuttingMachineParams = (data) => {
  if(socket) {
    socket.emit("put-default-cutting-machine-one-field", { ...data })
  }
}

const changeCuttingSpeed = (data) => {
  if(socket) {
    socket.emit("put-default-machine-cutting-speed", { ...data })
  }
}

const changeMachineMaxTolerance = (data) => {
  if (socket) {
    socket.emit("put-default-machine-max-tolerance", { ...data })
  }
}
const changeMachineToleranceMarkup = (data) => {
  if (socket) {
    socket.emit("put-default-machine-tolerance-markup", { ...data })
  }
}

//#------------------------------------------------------------

const changeBendingParams = (data) => {
  if(socket) {
    socket.emit("put-default-producer-bending-params", { ...data })
  }
}

//#------------------------------------------------------------

const changeDeburringParams = (data) => {
  if(socket) {
    socket.emit("put-default-deburring-params", { ...data })
  }
}
const changeChamferingParams = (data) => {
  if(socket) {
    socket.emit("put-default-chamfering-params", { ...data })
  }
}
const changeDrillingParams = (data) => {
  if(socket) {
    socket.emit("put-default-drilling-params", { ...data })
  }
}
const changeSimpleMachiningParams = (data) => {
  if(socket) {
    socket.emit("put-default-simple-machining-params", { ...data })
  }
}

//#------------------------------------------------------------

const changeMillingParams = (data) => {
  if(socket) {
    socket.emit("put-default-milling-params", { ...data })
  }
}
const changeLathingParams = (data) => {
  if(socket) {
    socket.emit("put-default-lathing-params", { ...data })
  }
}
const changeGradeMillingSpeed = (data) => {
  if(socket) {
    socket.emit("put-default-milling-speed", {...data})
  }
}
const changeGradeLathingSpeed = (data) => {
  if(socket) {
    socket.emit("put-default-lathing-speed", {...data})
  }
}
const changeMachineMaxRoughness = (data) => {
  if (socket) {
    socket.emit("put-default-machine-max-roughness", { ...data })
  }
}
const changeMachineRoughnessMarkup = (data) => {
  if (socket) {
    socket.emit("put-default-machine-roughness-markup", { ...data })
  }
}

//#------------------------------------------------------------

const changeTubeCuttingMachineParams = (data) => {
  if (socket) {
    socket.emit("put-default-tube-cutting-machine-params", {...data})
  }
}
const changeTubeCuttingMachineSpeed = (data) => {
  if (socket) {
    socket.emit("put-default-tube-cutting-speed", {...data})
  }
}

//#------------------------------------------------------------

const changePaintingParams = (data) => {
  if(socket) {
    socket.emit("put-default-painting-params", { ...data })
  }
}
const changePowderPaintingParams = (data) => {
  if(socket) {
    socket.emit("put-default-powder-painting-params", { ...data })
  }
}
const changeGalvanizingParams = (data) => {
  if(socket) {
    socket.emit("put-default-galvanizing-params", { ...data })
  }
}
const changeNickelPlatingParams = (data) => {
  if(socket) {
    socket.emit("put-default-nickel-plating-params", { ...data })
  }
}
const changeAnodizingParams = (data) => {
  if(socket) {
    socket.emit("put-default-anodizing-params", { ...data })
  }
}
const changeGalvanicZincPlatingParams = (data) => {
  if(socket) {
    socket.emit("put-default-galvanic-zinc-plating-params", { ...data })
  }
}
const changeHardeningParams = (data) => {
  if(socket) {
    socket.emit("put-default-hardening-params", {...data})
  }
}
const changeCaseHardeningParams = (data) => {
  if(socket) {
    socket.emit("put-default-case-hardening-params", {...data})
  }
}
const changeAnnealingParams = (data) => {
  if(socket) {
    socket.emit("put-default-annealing-params", {...data})
  }
}
const changeGlassBeadBlastingParams = (data) => {
  if(socket) {
    socket.emit("put-default-glass-bead-blasting-params", {...data})
  }
}
const changeSandBlastingParams = (data) => {
  if(socket) {
    socket.emit("put-default-sand-blasting-params", {...data})
  }
}

//#------------------------------------------------------------

const changeMaterialPrice = (data) => {
  if(socket) {
    socket.emit("put-default-sheet-metal-material-price", data)
  }
}
const changeBaseMaterialCertificateParams = (data) => {
  if (socket) {
    socket.emit("put-default-base-material-cert-fee", data)
  }
}
const changeAssemblyMaterialCertificateParams = (data) => {
  if (socket) {
    socket.emit("put-default-assembly-material-cert-fee", data)
  }
}
const changeMachiningMaterialPrice = (data) => {
  if(socket) {
    socket.emit("put-default-machining-material-price", { ...data })
  }
}
const changeTubeMaterialPrice = (data) => {
  if(socket) {
    socket.emit("put-default-tube-cutting-material-price", { ...data })
  }
}
const changeStandardTubeMaterialPrice = (data) => {
  if(socket) {
    socket.emit("put-default-tube-cutting-standard-material-price", { ...data })
  }
}

export {
  initializeSocket,
  changeCuttingMachineParams, changeCuttingSpeed,
  changeMachineMaxTolerance,changeMachineToleranceMarkup,

  changeBendingParams,

  changeDeburringParams, changeChamferingParams,
  changeDrillingParams, changeSimpleMachiningParams,
  
  changeMillingParams, changeLathingParams,
  changeGradeMillingSpeed, changeGradeLathingSpeed,
  changeMachineMaxRoughness, changeMachineRoughnessMarkup,

  changeTubeCuttingMachineParams, changeTubeCuttingMachineSpeed,

  changePaintingParams, changePowderPaintingParams,
  changeGalvanizingParams, changeNickelPlatingParams,
  changeAnodizingParams, changeGalvanicZincPlatingParams,
  changeHardeningParams, changeCaseHardeningParams,
  changeAnnealingParams, changeGlassBeadBlastingParams,
  changeSandBlastingParams,

  changeMaterialPrice, changeBaseMaterialCertificateParams,
  changeAssemblyMaterialCertificateParams, changeMachiningMaterialPrice,
  changeTubeMaterialPrice, changeStandardTubeMaterialPrice
}